import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import message from '../../utils/message';
import { resendConfirmation } from '../../reduxStore/actions/userActionsHelper';
import { clearResendConfirmationState } from '../../reduxStore/reducers/userReducersHelper';
import styles from '../../publicAsset/LinkExpiredPage.module.scss';

const LinkExpiredPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [showResendForm, setShowResendForm] = useState(false);

    const {
        isResendConfirmationLoading,
        isResendConfirmationSuccess,
        resendConfirmationError
    } = useSelector(state => state.user);

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (isResendConfirmationSuccess) {
            message.success('Confirmation email sent! Please check your inbox.');
            setEmail('');
            setShowResendForm(false);
            dispatch(clearResendConfirmationState());
        }
    }, [isResendConfirmationSuccess, dispatch]);

    useEffect(() => {
        if (resendConfirmationError) {
            message.error(resendConfirmationError);
            dispatch(clearResendConfirmationState());
        }
    }, [resendConfirmationError, dispatch]);

    const handleResendConfirmation = (e) => {
        e.preventDefault();

        if (!email) {
            message.error('Please enter your email address');
            return;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            message.error('Please enter a valid email address');
            return;
        }

        dispatch(resendConfirmation.request(email));
    };

    const handleRequestPasswordReset = () => {
        navigate('/forgot-password');
    };

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.iconWrapper}>
                    <svg
                        className={styles.icon}
                        width="120"
                        height="120"
                        viewBox="0 0 120 120"
                        fill="none"
                    >
                        <circle cx="60" cy="60" r="50" stroke="#FF6B6B" strokeWidth="4" fill="none" />
                        <path d="M40 40L80 80M80 40L40 80" stroke="#FF6B6B" strokeWidth="4" strokeLinecap="round" />
                    </svg>
                </div>

                <h1 className={styles.title}>Link Has Expired</h1>
                <p className={styles.message}>
                    The verification link you clicked has expired. Please choose an option below to continue.
                </p>

                {/* Option 1: Resend Account Confirmation */}
                <div className={styles.optionSection}>
                    <h3 className={styles.optionTitle}>Need to confirm your account?</h3>
                    {!showResendForm ? (
                        <button
                            className={styles.linkButton}
                            onClick={() => setShowResendForm(true)}
                        >
                            Resend Confirmation Email
                        </button>
                    ) : (
                        <form className={styles.resendForm} onSubmit={handleResendConfirmation}>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className={styles.emailInput}
                                required
                            />
                            <button
                                type="submit"
                                className={styles.resendButton}
                                disabled={isResendConfirmationLoading}
                            >
                                {isResendConfirmationLoading ? 'Sending...' : 'Send Confirmation Email'}
                            </button>
                            <button
                                type="button"
                                className={styles.cancelButton}
                                onClick={() => {
                                    setShowResendForm(false);
                                    setEmail('');
                                }}
                                disabled={isResendConfirmationLoading}
                            >
                                Cancel
                            </button>
                        </form>
                    )}
                </div>

                {/* Divider */}
                <div className={styles.divider}>
                    <span>OR</span>
                </div>

                {/* Option 2: Reset Password */}
                <div className={styles.optionSection}>
                    <h3 className={styles.optionTitle}>Need to reset your password?</h3>
                    <button
                        className={styles.primaryButton}
                        onClick={handleRequestPasswordReset}
                    >
                        Request New Password Reset Link
                    </button>
                </div>

                <button
                    className={styles.backButton}
                    onClick={() => navigate('/')}
                >
                    Back to Home
                </button>
            </div>
        </div>
    );
};

export default LinkExpiredPage;


